import { widgetApi } from './widget.api';

export const widgetActions = {
  async getWidgets({ commit }, payload) {
    try {
      commit('GET_WIDGETS_LOADING');
      const response = await widgetApi.getWidgets(payload);
      commit('GET_WIDGETS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_WIDGETS_ERROR', error.response);
    }
  },
  async getWidget({ commit }, id) {
    try {
      commit('GET_WIDGET_LOADING');

      const response = await widgetApi.getWidget(id);

      commit('GET_WIDGET_SUCCESS', response.data);
    } catch (error) {
      commit('GET_WIDGET_ERROR', error.response);
    }
  },
  async addWidget({ commit }, body) {
    try {
      commit('ADD_WIDGET_LOADING');

      const response = await widgetApi.addWidget(body);

      commit('ADD_WIDGET_SUCCESS', response.data);
    } catch (error) {
      commit('ADD_WIDGET_ERROR', error.response);
    }
  },
  async deleteWidget({ commit }, id) {
    try {
      commit('DELETE_WIDGET_LOADING');

      const response = await widgetApi.deleteWidget(id);

      commit('DELETE_WIDGET_SUCCESS', response.data);
    } catch (error) {
      commit('DELETE_WIDGET_ERROR', error.response);
    }
  },
  async updateWidget({ commit }, { id, body }) {
    try {
      commit('UPDATE_WIDGET_LOADING');

      const response = await widgetApi.updateWidget(id, body);

      commit('UPDATE_WIDGET_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_WIDGET_ERROR', error.response);
    }
  },
  async updateSequence({ commit }, body) {
    try {
      commit('UPDATE_WIDGET_SEQUENCE_LOADING');

      await widgetApi.updateSequence(body);

      commit('UPDATE_WIDGET_SEQUENCE_SUCCESS');
    } catch (error) {
      commit('UPDATE_WIDGET_SEQUENCE_ERROR', error.response);
    }
  },
};
